import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./SupportDialog.css";

export default function SupportDialog({ open, onClose }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="sm" fullWidth PaperProps={{ className: "supportDialogPaper" }}>
      <DialogTitle className="supportDialogTitle">{t("Support")}</DialogTitle>
      <DialogContent className="supportDialogContent">
        <Typography className="supportDialogText">
          {t("Support dialog message")}
        </Typography>
        <Typography className="supportDialogContactLine">
          {t("Email")}:{" "}
          <a href={`mailto:${t("Support email")}`} className="supportDialogLink">
            {t("Support email")}
          </a>
        </Typography>
        <Typography className="supportDialogContactLine">
          {t("Support phone label")}:{" "}
          <a href={`tel:${t("Support phone raw")}`} className="supportDialogLink">
            {t("Support phone display")}
          </a>&nbsp;(OR)&nbsp;
           <a href={`tel:${t("Support phone raw1")}`} className="supportDialogLink">
            {t("Support phone display1")}
          </a>
        </Typography>
      </DialogContent>
      <DialogActions className="supportDialogActions">
        <Button variant="outlined" className="supportDialogCloseButton" onClick={onClose}>
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
